import currencyFilter from "@/filters/currency.filter";

export default {
  install(app) {
    app.config.globalProperties.$cur = currencyFilter;
  },
};